<template>
  <el-container class="main-container">
    <div class="content-wrapper">
      <!-- Banner 区域 -->
      <div class="banner-container">
        <div class="banner">
          <img src="/static/ad3.jpg" class="bannerImg"></img>
          <!-- 搜索栏 -->
          <div class="tabs-nav">
            <!-- 左侧 tab -->
            <div class="tabs-left">
              <div class="product-tab">{{ t('productTab') }}</div>
              <div class="online-tab">{{ t('onlineTab') }}</div>
            </div>

            <!-- 右侧按钮 -->
            <el-button class="contact-button" type="primary">
              <router-link to="/ContactUs" class="a-style">{{ t('contactUs') }}</router-link>
              <i class="el-icon-arrow-left"></i>
            </el-button>
          </div>
        </div>
      </div>

      <!-- 筛选和表格 -->
      <div class="main-content">
        <div class="main">
          <div class="memory-filter-container">
            <!-- 顶部折叠/展开按钮 -->
            <div class="filter-toggle">
              <div @click="toggleFilters">
                <span class="toggle-text">
                  {{ filtersVisible ? t('hideFilters') : t('showFilters') }}
                </span>
              </div>
              <div class="filter-reset" @click="handleReset">{{ t('reset') }}</div>
            </div>

            <div class="filter-wrapper">
              <!-- 主内容区域 -->
              <div class="memory-title">
                {{ t('memory') }}
                <i :class="filtersVisible ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" class="filter-icon"></i>
              </div>

              <!-- 筛选器内容 -->
              <div v-show="filtersVisible" class="filter-content">
                <div class="filter-categories">
                  <div v-for="category in categories" :key="category.name" class="category-group">
                    <div class="category-title">{{ t(category.name) }}</div>
                    <el-checkbox-group v-model="selectedFilters[category.name]">
                      <el-checkbox
                          v-for="item in category.items"
                          :key="item.content"
                          :label="item.content"
                          class="category-item"
                          @change="handleFilterChange"
                      >
                        {{ item.content }}
                      </el-checkbox>
                    </el-checkbox-group>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 表格内容 -->
          <div class="table-area">
            <div class="table-header">
              <div class="product-title">{{ t('productTitle') }}</div>
              <div class="items-count">{{total}}{{ t('itemsCount') }}</div>
            </div>
            <product-table
                :filters="filters"
                :search="searchKeyword"
                :t="t"
                :currentLang="currentLang"
                :modelType="modelType"
                :searchKeyword="searchKeyword"
                class="product-table"
            />
          </div>
        </div>
      </div>
    </div>
  </el-container>
</template>

<script>
import ProductTable from './components/ProductTable.vue'
import {
  listCapacity, listChipManufacturer, listChipOragnrzation, listFeature,
  listManufacturer, listOperatingTemperature, getModelManager, listProduct, getNews
} from "@/utils/http";

export default {
  components: { ProductTable },
  name: "productSearch",
  props: ['t', 'currentLang'],
  data() {
    return {
      filters: {
        capacity: [],
        chip: []
      },
      params:{
        eType:0,
        type:1
      },
      filtersVisible: false,
      productList:[],
      modelType:0,
      total:0,
      currentPage: 1,
      pageSize: 10,
      selectedFilters: {
        'Capacity': [],
        'Chip Manufacturer': [],
        'Chip Organization': [],
        'Feature': [],
        'Manufacturer': [],
        'Operating Temperature': []
      },
      categories: [
        {
          name: 'Capacity',
          items: ['4GB', '8GB', '16GB', '32GB', '64GB']
        },
        {
          name: 'Chip Manufacturer',
          items: ['MICRON', 'SAMSUNG']
        },
        {
          name: 'Chip Organization',
          items: ['1 G x 8', '1G x 8', '512M x 8']
        },
        {
          name: 'Feature',
          items: ['ECC', 'Registered', 'Unbuffered']
        },
        {
          name: 'Manufacturer',
          items: ['Advantech', 'Micron']
        },
        {
          name: 'Operating Temperature',
          items: [
            '0 - 85°C (32 - 185°F)',
            '0 - 95°C (32 - 203°F)',
            '-40 - 85°C (-40 - 185°F)'
          ]
        }
      ],
      capacityList:[],
      chipManufacturerList:[],
      chipOragnrzationList:[],
      featureList:[],
      manufacturerList:[],
      operatingTemperatureList:[],
      searchKeyword:null
    }
  },
  watch: {
    currentLang(newVal, oldVal) {
      this.onLangChange(newVal);
    },
  },
  mounted() {
    this.searchKeyword = this.$route.query.search;
    this.modelType = this.$route.params.type;
    if (!this.modelType) {
      this.modelType = 0;
    } else {
      this.params.type = this.modelType;
    }

    this.initProductList();
    this.initOperatingTemperatureList();
    this.initManufacturerList();
    this.initFeatureList();
    this.initChipManufacturerList();
    this.initCapacityList();
    this.initChipOragnrzationList()
  },
  methods: {
    toggleFilters() {
      this.filtersVisible = !this.filtersVisible
    },
    handleReset() {
      Object.keys(this.selectedFilters).forEach(key => {
        this.selectedFilters[key] = []
      })
      this.filters = {
        capacity: [],
        chipManufacturer: [],
        chipOragnrzation: [],
        feature: [],
        manufacturer: [],
        operatingTemperature: []
      };
    },
    handleFilterChange() {
      this.filters = {
        capacity: this.selectedFilters['Capacity'],
        chipManufacturer: this.selectedFilters['Chip Manufacturer'],
        chipOragnrzation: this.selectedFilters['Chip Organization'],
        feature: this.selectedFilters['Feature'],
        manufacturer: this.selectedFilters['Manufacturer'],
        operatingTemperature: this.selectedFilters['Operating Temperature']
      };
    },
    onLangChange(lang) {
      if (lang === 'zh') {
        this.params.eType = 0;
      } else {
        this.params.eType = 1;
      }
      this.initProductList();
    },
    initProductList() {
      if (this.searchKeyword) {
        const param = {
          productName: this.searchKeyword,
          productRemark: this.searchKeyword
        }
        listProduct(param).then(response => {
          this.productList = response.rows;
          this.total = response.total;
        })
      } else {
        listProduct({type: this.modelType}).then(response => {
          this.productList = response.rows;
          this.total = response.total;
        })
      }
    },
    initCapacityList() {
      listCapacity().then(response => {
        for (var i = 0; i < this.categories.length; i++) {
          if (this.categories[i].name === 'Capacity') {
            this.categories[i].items = response.data;
            break;
          }
        }
      })
    },
    initChipManufacturerList() {
      listChipManufacturer().then(response => {
        for (var i = 0; i < this.categories.length; i++) {
          if (this.categories[i].name === 'Chip Manufacturer') {
            this.categories[i].items = response.data;
            break;
          }
        }
      })
    },
    initChipOragnrzationList() {
      listChipOragnrzation().then(response => {
        for (var i = 0; i < this.categories.length; i++) {
          if (this.categories[i].name === 'Chip Organization') {
            this.categories[i].items = response.data;
            break;
          }
        }
      })
    },
    initFeatureList() {
      listFeature().then(response => {
        for (var i = 0; i < this.categories.length; i++) {
          if (this.categories[i].name === 'Feature') {
            this.categories[i].items = response.data;
            break;
          }
        }
      })
    },
    initManufacturerList() {
      listManufacturer().then(response => {
        for (var i = 0; i < this.categories.length; i++) {
          if (this.categories[i].name === 'Manufacturer') {
            this.categories[i].items = response.data;
            break;
          }
        }
      })
    },
    initOperatingTemperatureList() {
      listOperatingTemperature().then(response => {
        for (var i = 0; i < this.categories.length; i++) {
          if (this.categories[i].name === 'Operating Temperature') {
            this.categories[i].items = response.data;
            break;
          }
        }
      })
    },
  }
}
</script>

<style scoped>
/* 基础样式 */
section, div, img {
  margin: 0;
  padding: 0;
}

.a-style {
  text-decoration: none;
  color: inherit;
}

.main-container {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
}

.content-wrapper {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
}

.banner-container {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  overflow: hidden;
}

.banner {
  width: 100%;
  height: auto;
  position: relative;
}

.tabs-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  border-bottom: 1px solid #000;
  background-color: #fff;
  width: 50%;
  max-width: 1000px;
  position: absolute;
  z-index: 999;
  margin-top:-100px;
  margin-left:25%;
}

.tabs-left {
  color: #000000;
  display: flex;
  font-size: 18px;
  text-align: center;
}

.product-tab {
  border-right: 2px solid #000;
  width: 100px;
}

.online-tab {
  width: 150px;
  text-align: left;
  margin-left: 30px;
}

.contact-button {
  background: linear-gradient(to right, #1e1e1e, #2c2c2c);
  color: white;
  border: none;
  height: 40px;
  padding: 0 20px;
  font-weight: bold;
}

.contact-button i {
  margin-left: 5px;
}

.main-content {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
}

.main {
  display: flex;
  padding: 20px 60px;
  //max-width: 1600px;
  margin: 0 auto;
  background: #fff;
}

.memory-filter-container {
  width: 240px;
  background-color: #fff;
  font-family: Arial, sans-serif;
  margin-top: 50px;
}

.filter-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  color: #333;
  font-weight: bold;
}

.toggle-text {
  border: 1px solid #34689B;
  color: #34689B;
  padding: 5px 20px;
}

.filter-wrapper {
  border: 1px solid #D5D5D5;
  margin-top: 10px;
}

.memory-title {
  padding: 10px;
  font-size: 18px;
  font-weight: bold;
  color: #34689B;
  border-top: 2px solid #34689B;
  background-color: #EEEEEE;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #D8D8D8;
}

.filter-reset {
  padding: 10px 16px;
  color: #34689B;
  cursor: pointer;
  text-align: right;
  font-size: 14px;
}

.filter-categories {
  padding: 0 16px;
  margin-top: 20px;
}

.category-group {
  margin-bottom: 20px;
}

.category-title {
  font-size: 14px;
  color: #666;
  margin-bottom: 12px;
  font-weight: normal;
}

.category-item {
  display: block;
  margin: 6px 0;
}

.table-area {
  width: calc(100% - 270px);
  margin-left: 30px;
}

.table-header {
  width: 100%;
  text-align: center;
  border-bottom: 2px solid #34689B;
  font-size: 40px;
  color: #000000;
  height: 100px;
}

.product-title {
  font-size: 40px;
}

.items-count {
  font-size: 14px;
  text-align: left;
  margin-top: 30px;
}

.product-table {
  margin-top: 40px;
}

/* 高分辨率适配 */
@media screen and (min-width: 1921px) {
  .banner {
    background-position: center center;

  }
}

/* 纯移动端样式 - 只在小于768px时生效 */
@media screen and (max-width: 768px) {
  .banner {
    width: 100%;
    height: 300px;
    background-position: top center;
  }

  .tabs-nav {
    width: 90%;
    margin-top: 200px;
    flex-direction: column;
    align-items: flex-start;
    padding: 15px;
  }

  .tabs-left {
    width: 100%;
    margin-bottom: 15px;
  }

  .contact-button {
    width: 100%;
    margin-top: 10px;
  }

  .main {
    flex-direction: column;
    padding: 15px;
    max-width: 100%;
  }

  .memory-filter-container {
    width: 100%;
    margin-top: 20px;
  }

  .table-area {
    width: 100%;
    margin-left: 0;
    margin-top: 20px;
  }

  .table-header {
    height: auto;
    padding: 15px 0;
  }

  .product-title {
    font-size: 28px;
  }

  .items-count {
    margin-top: 15px;
  }

}

/* 小屏幕手机调整 */
@media screen and (max-width: 480px) {
  .banner{
    width: 100%;
    height: 220px;

  }

  .bannerImg{
    width:100%;
    height:auto;
    margin-top:0px;
    transform: translate(-4%, 15%) scale(1.7); /* 居中并放大 */
  }
  .tabs-nav {
    margin-top: 0px;
    margin-left:0% !important;
    width:94% !important
  }

  .product-tab,
  .online-tab {
    font-size: 16px;
  }

  .memory-title {
    font-size: 16px;
    padding: 8px 10px;
  }

  .filter-categories {
    padding: 0 10px;
  }

  .category-title {
    font-size: 13px;
  }

  .product-title {
    font-size: 24px;
  }

  .items-count {
    font-size: 13px;
  }
}
</style>
